/** Set to false to restore live API data across the admin app */
export const EMPTY_PREVIEW = false;

const ok = (data) => ({ status: true, message: "Empty preview", data });

const EMPTY_LIST = {
  docs: [],
  totalDocs: 0,
  totalPages: 1,
  page: 1,
  limit: 10,
};

export const EMPTY_DASHBOARD = {
  stats: {
    students: 0,
    teachers: 0,
    classes: 0,
    activities: 0,
    studentRateMonth: 0,
    teacherRateMonth: 0,
    studentsPresentToday: 0,
    teachersPresentToday: 0,
  },
  attendance: {
    students: {
      breakdown: {
        labels: ["Present", "Absent", "Leave", "Holiday"],
        values: [0, 0, 0, 0],
        rate: 0,
      },
    },
    teachers: {
      breakdown: {
        labels: ["Present", "Absent", "Leave", "Holiday"],
        values: [0, 0, 0, 0],
        rate: 0,
      },
    },
    weekly: {
      labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      studentsPresent: [0, 0, 0, 0, 0, 0, 0],
      teachersPresent: [0, 0, 0, 0, 0, 0, 0],
      studentsPresentTotal: 0,
      teachersPresentTotal: 0,
    },
    overview: {
      range: "thisWeek",
      labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      studentsPresent: [0, 0, 0, 0, 0, 0, 0],
      teachersPresent: [0, 0, 0, 0, 0, 0, 0],
      studentsPresentTotal: 0,
      teachersPresentTotal: 0,
    },
  },
  calendar: { marks: [], monthItems: [], upcoming: [] },
};

const BY_ID_MATCHERS = [
  ["getchildbyid", { child: null }],
  ["getteacherbyid", { teacher: null }],
  ["getparentbyid", { parent: null }],
  ["getclassroombyid", { classroom: null }],
  ["getticketbyid", { ticket: null }],
  ["getpostbyid", { post: null }],
  ["gethomeworkbyid", { homework: null }],
  ["getvoucherbyid", { fee: null }],
  ["getinventorybyid", { inventory: null }],
  ["getactivitybyid", { activity: null }],
  ["getcategorybyid", { category: null }],
  ["notificationdetail", { notification: null }],
  ["getproductbyid", { product: null }],
  ["getservicebyid", { service: null }],
  ["geteventbyid", { event: null }],
  ["getbookbyid", { book: null }],
  ["getstatebyid", { state: null }],
  ["getpositionbyid", { position: null }],
  ["getrepresentativebyid", { representative: null }],
  ["getorderbyid", { order: null }],
  ["getnewsbyid", { news: null }],
  ["gethistorybyid", { history: null }],
  ["getquerybyid", { query: null }],
  ["getarticlebyid", { article: null }],
  ["getuserbyid", { user: null }],
];

function shouldBypassEmptyPreview(path) {
  const p = path.toLowerCase();
  return p.includes("/auth/signin") || p.includes("/auth/register");
}

export function getEmptyGetResponse(path) {
  if (!EMPTY_PREVIEW || shouldBypassEmptyPreview(path)) {
    return null;
  }

  const p = path.toLowerCase();

  if (p.includes("/dashboard/overview")) {
    return ok(EMPTY_DASHBOARD);
  }

  if (p.includes("getunreadadminnotifications")) {
    return ok({ count: 0, totalUnreadCount: 0, notifications: [] });
  }

  if (p.includes("getunreadticketcount")) {
    return ok({ count: 0 });
  }

  if (p.includes("searchparents")) return ok({ parents: [] });
  if (p.includes("searchstudents")) return ok({ students: [] });
  if (p.includes("searchteachers")) return ok({ teachers: [] });
  if (p.includes("searchclassrooms")) return ok({ classrooms: [] });

  if (p.includes("attendancebymonth")) return ok({ attendance: [] });
  if (p.includes("getallholidays")) return ok({ holidays: [] });
  if (p.includes("getallclasstimetables")) return ok({ slots: [] });
  if (p.includes("getticketmessages")) return ok(EMPTY_LIST);

  for (const [needle, payload] of BY_ID_MATCHERS) {
    if (p.includes(needle)) {
      return ok(payload);
    }
  }

  if (
    p.includes("getall") ||
    p.includes("/get")
  ) {
    return ok(EMPTY_LIST);
  }

  if (
    p.includes("togglestatus") ||
    p.includes("delete") ||
    p.includes("logout")
  ) {
    return { status: true, message: "Empty preview" };
  }

  return ok({});
}
